import { Translate } from '@travel/translation';
import cx from '@travel/ui/utils/classnames';

import { Link } from 'core/universalRouter/Link';

import { PAGE_INDICATOR } from 'constants/common';
import { normalizePathIdentifier } from 'utils/search';

import styles from './loadMoreButton.module.scss';

type Props = {
  onClick: () => void;
  customHost?: string;
  className?: string;
  to: string;
  pageNumber?: number;
};

function LoadMoreButton(props: Props) {
  const { className, to, pageNumber = 1, onClick, customHost } = props;
  const nextPageNumber = pageNumber + 1;
  const { normalizePath } = normalizePathIdentifier(to);
  const nextPageUrl = `${normalizePath}?${PAGE_INDICATOR}=${nextPageNumber}`;

  const wrapperClick = (e) => {
    e.preventDefault();
    onClick();
  };

  const classNames = cx(
    styles.flexWrapper,
    styles.button,
    className,
    styles.primary,
    styles.border,
  );

  return (
    <Link to={nextPageUrl} className={classNames} onClick={wrapperClick} customHost={customHost}>
      <div data-testid="LoadMoreButton-seeMore" key="label" className={styles.textWithIconWrapper}>
        <Translate id="Review_Common.SeeMore" />
      </div>
    </Link>
  );
}

export default LoadMoreButton;
